module.exports = __webpack_public_path__ + "img/monthly-summary.fccc01c6.png";